module.exports = __webpack_public_path__ + "static/img/w-8.7e9b376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-8.jpg
// module id = sQkK
// module chunks = 1